import {Validator} from '@/type/validation/result';
import {在庫数区分型} from '@/type/refstock/types';
import { 在庫商品区分型 } from '@/type/stock/item';
import {半角カナ禁止, 年月書式, 必須入力} from '@/type/validation/validator';

export interface 在庫場所型 {
  部署コード: string;
  部署名: string;
}

export interface 在庫照会ヘッダー型 {
  在庫場所: 在庫場所型;
  在庫年月: string;
}

export interface 在庫照会明細型 {
  商品コード: string;
  販売GTINコードorJANコード: string;
  商品区分: string;
  使用区分: string;
  メーカー名: string;
  在庫商品名: string;
  規格容量: string;
  商品入数: number;
  単位: string;
  当月入庫数: number;
  当月出庫数: number;
  当月在庫数: number;
  納入単価: number;
  当月在庫金額: number;
}

export interface 在庫照会結果型 {
  ヘッダー: 在庫照会ヘッダー型;
  明細一覧: 在庫照会明細型[];
  アラートメッセージ: string;
}

export class 在庫照会検索条件型 {
  constructor(public 在庫場所: string = '',
              public 在庫年月: string = '',
              public 在庫数区分検索条件: 在庫数区分型|null = null,
              public メーカー名検索条件: string = '',
              public 商品名カナ検索条件: string = '',
              public 商品区分検索条件: 在庫商品区分型|null = null,
              public 使用区分検索条件: string|null = null,
  ) {}
}

export const 在庫照会検索条件型バリデータ一覧: Validator[] = [
  {
    name: '在庫年月',
    constraints: [
      {method: 必須入力, message: '在庫年月を入力してください'},
      {method: 年月書式, message: '在庫年月の書式が不正です'},
    ],
  },
  {
    name: '商品名カナ検索条件',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];
